import axios from "axios";
import { getConfiguredHost, getServiceHost, USE_PROD } from "./runtimeHost";

export { USE_PROD };

// Allow parallel local previews without redirecting production API traffic.
const localApiPort = process.env.NEXT_PUBLIC_LOCAL_API_PORT || "3002";
if (!USE_PROD && (!/^\d+$/.test(localApiPort) || Number(localApiPort) < 1 || Number(localApiPort) > 65535))
  throw new Error("NEXT_PUBLIC_LOCAL_API_PORT must be a valid port");

export let BASE_URL = USE_PROD
  ? "https://" + getServiceHost() + "/api/v1/"
  : "http://" + getConfiguredHost() + ":" + localApiPort + "/api/v1/";

export const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: "0",
  },
  withCredentials: true,
  timeout: process.env.NODE_ENV === "production" ? 10000 : 10000000,
});

export const puzzleApi = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: "0",
  },
  withCredentials: true,
  timeout: process.env.NODE_ENV === "production" ? 10000 : 10000000,
});
